module.exports = __webpack_public_path__ + "media/tycho2t3_80_mz.2f4b61ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_mz.jpg
// module id = 1094
// module chunks = 0